export const version = "1.0.2-daily-20260413-0";
export const channel = "daily";
export const gitcommit = "b9180d37e";
